import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/files')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/file' })
  },
})
